module.exports = __webpack_public_path__ + "img/G.d2eaf874.svg";